import preferencesServices from '@/services/preferences.services.js';
import mixin from '@/mixin/index.js';
import storage from '@/plugins/storage.plugins.js';
const { _getTimestamp, _getLabel } = mixin.methods;

const root = { root: true };
const modes = {
    'recents': {
        name: _getLabel('ITEMS_MODES_RECENTS'),
        mode: 'recents',
        orderByClasses: true,
        handler: async ({ commit, dispatch, state }) => {
            const now = _getTimestamp();
            if (!!state.recentlySeen && (now - state.recentlySeenIssued < 300000)) {
                state.preferences = state.recentlySeen;
                return;
            }
            state.recentlySeenIssued = now;
            state.recentlySeen = await preferencesServices.getRecentlySeen();
            state.preferences = state.recentlySeen;
        }
    },
    'searches': {
        name: process.env.VUE_APP_ENV === "partners" ? null : _getLabel('ITEMS_MODES_SEARCH'),
        mode: 'searches',
        orderByClasses: false,
        handler: async ({ commit, dispatch, state }) => {
            const now = _getTimestamp();
            if (!!state.searchList || !!state.searchListIssued) {
                state.preferences = state.searchList;
                return;
            }
            state.searchListIssued = now;
            state.searchList = await preferencesServices.getSearchList();
            state.searchListIssued = null;
            state.preferences = state.searchList;
        }
    }
}

export default {
    async openRecentlySeen({ dispatch }) {
        dispatch("general/logEvent", 'openRecentlySeen', root);
        dispatch('general/routePathRedirect', { path: '/items/recents' }, root)
    },
    async openGlobalSearches({ dispatch }) {
        dispatch("general/logEvent", 'openGlobalSearches', root);
        dispatch('general/routePathRedirect', { path: '/items/searches' }, root)
    },
    async getPreferencesByMode({ commit, dispatch, state }, { mode }) {
        try {
            commit('drugs/setCategory', {
                orderByClasses: modes[mode].orderByClasses,
                portugueseName: modes[mode].name,
                name: modes[mode].name,
                hideBrandSelection: true,
                vaccines_suplements_serums: false,
                human_products: false,
                displayProducts: true,
            }, root);
            await modes[mode].handler({ commit, dispatch, state });
        } catch {
            state.recentlySeen = null;
            dispatch("general/showError", null, root);
            dispatch('general/routeRedirect', { name: 'home' }, root);
        }
    },
    async getDeviceRecentlySeen({ state }) {
        state.deviceRecentlySeen = await storage.storageSelect('configuration', 'deviceRecentlySeen') || state.deviceRecentlySeen;
    },
    async setDeviceRecentlySeen({ state }, { item }) {
        const callback = (args) => { console.log(args); };
        state.deviceRecentlySeen = state.deviceRecentlySeen || [];
        state.deviceRecentlySeen.push(item);
        storage.storageUpsert('configuration', 'deviceRecentlySeen', state.deviceRecentlySeen, callback, callback);
    },
    async postFakeDoorClick({ commit }, resource) {
        commit('general/setConfirmModel', {
            active: true,
            text: _getLabel(`FAKE_DOORS_${{
                '1655150373366': 'ALGORITHMS',
                '1655994505075': 'DISEASES'
            }[resource]}`),
            confirmText: _getLabel("FAKE_DOOR_YES"),
            closeText: _getLabel("FAKE_DOOR_NO"),
            action: 'preferences/postFakeDoorClickConfirm',
            parameters: { resource, confirm: true },
            cancelAction: 'preferences/postFakeDoorClickConfirm',
            cancelParameters: { resource, confirm: false },
        }, root);
        await preferencesServices.postFakeDoorClick({ resource });
    },
    async postFakeDoorClickConfirm({ commit }, { resource, confirm }) {
        console.log({ resource, confirm });
        await preferencesServices.postFakeDoorClick({ resource, confirm });
    },
}